import { Box } from "@mui/material";

interface IDocumentDetailBasicWrapper
{
    children: React.ReactNode;
    isSidebarCollapsed: boolean;
}

export default function DocumentDetailBasicWrapper({ children, isSidebarCollapsed }: IDocumentDetailBasicWrapper)
{
    return (
        <Box sx={{
            display: 'flex',
            marginTop: '26px',
         }}>
             <Box sx={{
                 width: "100%",
                 margin: "0 5px",
                 height: 20,
                 justifyContent: 'start',
                 display: 'flex',
                 alignItems: 'start'
             }}>
                { children }
            </Box>
        </Box>
    )
}